<template>
    <div class="vip-u overflow-hidden">
        <div class="absolute top-0 left-0 w-full h-full z-2 w-100% h-100% bg-#000/50"
            v-if="[4].includes(userInfo?.role) && vipStore.getVipPlusPackage()">
        </div>
        <div class="h-142px relative overflow-hidden" v-if="![4, 5].includes(userInfo?.role)">
            <div class="absolute top-90px left-0 ml-20px text">
                VIP Ultra
            </div>
        </div>
        <div class="h-132px relative overflow-hidden" v-else>
            <div class="absolute top-60px left-50% -translate-x-1/2 w-full h-88px z-1 w-302px">
                <img src="@/assets/images/vip/caidai-u.svg" alt=""
                    class="w-full h-full absolute top-0 left-0 z-1"></img>
            </div>
            <div class="absolute top-70px left-0 text-center!  w-100%">
                <div class="text text-center! text-20px!">
                    Ultra VIP Activated
                </div>
                <span class="color-#888! text-14px">
                    Expires on: {{ formatDate(userInfo?.subscribeExpired) }}
                </span>
            </div>
        </div>
        <div class="vip-u-item w-full h-182px relative" v-if="false">
            <img src="@/assets/images/vip/vip-u.webp" alt="" class="w-full h-full absolute top-0 left-0 z-1"></img>
            <div>
                <div v-if="[5].includes(userInfo?.role)" class="absolute z-2 top-80px left-50% -translate-x-1/2 w-100%">
                    <img src="@/assets/images/vip/caidai-vip-plus.webp" alt=""
                        class="w-302px h-71px absolute top-0 left-10%"></img>
                    <div class="vip-u-text">
                        {{ [5].includes(userInfo?.role) ? ` ${currentVipUltraPackage} VIP Ultra` : 'Join VIP Ultra' }}
                    </div>
                    <div class="vip-u-text-2">
                        You have subscribed
                    </div>
                </div>
                <div v-else>
                    <div
                        class="flex gap-10px tab-subscribe-box overflow-x-auto p-20px z-2 flex flex-nowrap gap-10px w-100% items-center">
                        <div v-for="(value, index) in vipPerksUltra?.ultra?.packagesList"
                            :class="activePackage === index ? 'subscribe-active' : ''"
                            class="tab-subscribe-item color-#fff flex-shrink-0 text-center"
                            @click="handleSubscribe(value, index)">

                            <div v-if="index === 0 && (currentVipUltraPackage) !== 'Monthly'"
                                class="absolute! top--10px left-0  w-56px h-20px off-pic-box text-center flex items-center justify-center">
                                <img src="@/assets/images/vip/Tag.svg" alt="" class="w-46px h-20px"></img>
                            </div>

                            <div class="text-12px font-500">
                                {{ index === 0 ? 'Monthly' : index === 1 ? 'Quarterly' : 'Yearly' }}
                            </div>
                            <div class="text-16px font-800">
                                <span class="text-10px">$</span> {{ value.originPrice / 100 }}
                            </div>
                            <div class="text-9px font-500 color-text-1" v-if="index === 0">
                                Only $<span class="color-#fff">{{ value.originPrice / 100 }}</span> Per <br>
                                Monthly
                            </div>
                            <div class="text-9px font-500 color-text-1" v-if="index === 1">
                                <span class="color-#fff">
                                </span>Only $<span class="color-#fff">{{ (value.price / 100 / 3).toFixed(2)
                                    }}</span><br> per months
                            </div>
                            <div class="text-9px font-500 color-text-1" v-if="index === 2">
                                Only $ <span class="color-#fff">{{ (value.price / 100 / 12).toFixed(2) }}</span> <br>per
                                week
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="vip-u-benefit-box p-20px pt-40px">
            <div class="vip-u-benefit-list px-4px relative">
                <div
                    class="flex color-#FFFFFF h-50px text-12px relative lh-50px text-11px font-600  justify-between px-2px header-item">
                    <div class="w-160px text-left ml-10px">
                        Member's Privileges
                    </div>
                    <div class="w-57px text-center color-#BE8CFF">
                        Ultra
                    </div>
                    <div class="w-57px text-center color-text-1">
                        Plus
                    </div>
                </div>
                <div class="overflow-y-auto" :class="[5].includes(userInfo?.role) ? 'h-58vh' : 'h-58vh'">

                    <div v-for="item in vipBenefitList(vipPerksUltra)"
                        class="text-12px flex items-center justify-between px-2px benefit-item h-40px">
                        <div class="w-165px text-center flex items-center ml-5px">
                            <div class="mr-6px">
                                <img :src="item.titleImg" alt="" class="w-18px h-18px"></img>
                            </div>
                            <div class="color-#fff text-12px">
                                {{ item.title }}
                            </div>
                        </div>
                        <div class="w-57px justify-center items-center color-#BE8CFF flex">
                            <div class="flex items-center justify-center font-600 text-12px">
                                <div class="flex items-center justify-center flex-col " v-if="item.extraUltra">
                                    Extra
                                    <div class="flex items-center justify-center w-12px h-12px" v-if="item.crystalImg">
                                        {{ item.extraUltra }}
                                        <img :src="item.crystalImg" alt="" class="w-100% h-100%"></img>
                                    </div>
                                </div>
                                <div v-if="item.extentedMemory">
                                    {{ item.extentedMemory }}
                                </div>
                                <div v-if="item.extraCrystalImgPrice">
                                    {{ item.extraCrystalImgPrice }}
                                </div>
                            </div>
                            <div class="color-text-1 text-12px font-600">
                                <!-- {{ item.ultra }} -->
                            </div>
                            <div class="flex items-center justify-center w-12px h-8px" v-if="item.duiImg">
                                <img :src="item.duiImg" alt="" class="w-100% h-100%"></img>
                            </div>
                        </div>
                        <div class="w-57px text-center color-text-1 flex items-center justify-center">
                            <div class="flex items-center justify-center flex-col  text-12px" v-if="item.extraPlus">
                                Extra
                                <div class="flex items-center justify-center w-12px h-12px" v-if="item.crystalImg">
                                    {{ item.extraPlus }}
                                    <img :src="item.crystalImg" alt="" class="w-100% h-100%"></img>
                                </div>
                            </div>
                            <div class="flex items-center justify-center flex-col font-600 text-12px"
                                v-if="item.extraCrystalImgPriceUltra">
                                {{ item.extraCrystalImgPriceUltra }}
                            </div>
                            <div class="flex items-center justify-center flex-col font-600 text-12px"
                                v-if="item.extentedPMemory">
                                {{ item.extentedPMemory }}
                            </div>
                            <div class="flex items-center justify-center w-12px h-8px" v-if="item.dui">
                                <img :src="item.dui" alt="" class="w-100% h-100%"></img>
                            </div>
                        </div>
                    </div>
                    <div class="h-100px"></div>

                </div>

                <div class="top">
                </div>
                <div class="bottom">
                </div>
                <div class="absolute top--30px right-95px">
                    <img src="@/assets/images/vip/vip_ultra.webp" class="w-28px h-28px">
                </div>
            </div>
        </div>
        <div class="p-20px py-0! pt-10px! absolute bottom-0 left-0 right-0 bg-#19100F tab-box">
            <div class="flex items-center justify-center" v-if="![4, 5].includes(userInfo?.role)">
                <div class="flex items-center justify-center w-14px h-14px">
                    <img src="@/assets/images/home/crystal.webp" class="w-100% h-100%">
                </div>
                <div class="text-14px">
                    {{ vipPerksUltra?.ultra?.packagesList[0]?.giftAmount + vipPerksUltra?.ultra?.packagesList[0]?.amount
                    }}/Month
                </div>

                <div class="text-12px color-#888 mt-2px">
                    (Valued at ${{ vipPerksUltra?.ultra?.packagesList[0].price / 100 }})
                </div>
            </div>
            <div v-if="![4, 5].includes(userInfo?.role)" class="h-70px flex items-center justify-center">
                <div class="subscribe-now-btn mt-0!" @click="handleSubscribeNow">
                    Subscribe Now
                </div>
            </div>
            <div class="flex gap-10px color-text-1 justify-between py-10px">
                <div class="text-12px font-500 underline" @click="router.push('/terms')">
                    Terms of Use
                </div>
                <!-- <div class="text-12px font-500">
                    Cancel at any time
                </div> -->
                <div class="text-12px font-500 underline" @click="router.push('/policy')">
                    Privacy Policy
                </div>
            </div>
        </div>
        <!-- 挽留弹窗 -->
        <Transition name="retention-popup">
            <div v-if="showRetentionPopup" class="retention-popup-overlay" @click.self="handleCloseRetention">
                <div class="retention-popup-wrapper">
                    <div class="retention-popup-container">
                        <!-- 皇冠图标区域 -->
                        <div class="retention-icon-wrapper">
                            <div class="retention-icon-border">
                                <div class="retention-icon-circle">
                                    <img src="@/assets/images/vip/stay_uicon.svg" alt="" class="retention-crown-icon">
                                </div>
                            </div>
                        </div>

                        <!-- 标题 -->
                        <div class="retention-title">Still hesitating?</div>

                        <!-- 描述 -->
                        <div class="retention-description">
                            Once unlocked, you won't need to worry about diamond consumption.
                        </div>

                        <!-- 按钮组 -->
                        <div class="retention-buttons">
                            <div class="retention-btn retention-btn-secondary" @click="handleCloseRetention">
                                Next time
                            </div>
                            <div class="retention-btn retention-btn-primary" @click="handleSubscribeNow">
                                Buy now
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Transition>
    </div>
</template>

<script setup lang="ts">
import { VipAPI } from '@/services/vip'
import { theme } from '@/styles/theme'
import { vipBenefitList } from '../index'
import { useRouter, useRoute } from 'vue-router'
import { ref, computed } from 'vue'
import { useUserStore } from '@/stores/user'
import { useVipStore } from '@/stores/vip'
import { useBurialPointStore } from '@/stores/burialPoint'
import { showLoadingToast, showSuccessToast, showErrorToast, closeToast } from '@/utils/toast'
const userStore = useUserStore()
const router = useRouter()
const vipStore = useVipStore()
const vipUltraItem = ref<any>({})
const showRetentionPopup = ref(false)
const burialPointStore = useBurialPointStore()
const route = useRoute()
const props = defineProps({
    vipBenefitList: {
        type: Function,
        default: () => () => []
    },
    vipPerksUltra: {
        type: Object,
        default: () => { }
    },
    subscribePackagesCount: {
        type: Object,
        default: () => { }
    }
})

const activePackage = ref<number>(0)
const userInfo = computed(() => userStore.userInfo)
// 🔧 使用 computed 避免递归更新
const currentVipUltraPackage = computed(() => (vipStore.getVipUltraPackage()))
const handleSubscribe = (value: any, index: any) => {
    activePackage.value = index
    value.isVip = true
    vipUltraItem.value = value
}
const handleSubscribeNow = async () => {
    showRetentionPopup.value = false
    showLoadingToast('Purchasing...')
    // 文风功能选择曝光埋点
    if (route.query?.isStyle === 'true') {
        burialPointStore.setIsStyle(true)
    }
    if (route.query?.isPerspective === 'true') {
        burialPointStore.setIsPerspective(true)
    }
    localStorage.setItem('nowMsgCost', String(userStore.msgCost))
    if (!vipUltraItem.value.isVip) {
        vipUltraItem.value = props.vipPerksUltra?.ultra?.packagesList[activePackage.value]
        vipUltraItem.value.isVip = true
    }
    try {
        const res = await VipAPI.getSubscribePackagesCount({
            productId: props.vipPerksUltra?.ultra?.packagesList[0].productId
        })
        if (res.code === 200) {
            showSuccessToast('Purchase successful')
            userStore.getUserInfo()
            // userStore.loginTouristFunc()
            // handleCloseRetention()
        } else {
            showErrorToast(res.message)
        }
    } catch (error) {
        closeToast()
    } finally {
        closeToast()
    }

}
const handleShowRetentionPopup = () => {
    showRetentionPopup.value = true
}

const formatDate = (ts: number) => {
    const date = new Date(ts * 1000); // 秒 → 毫秒
    const pad = (n: number) => String(n).padStart(2, '0');

    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

const handleCloseRetention = () => {
    showRetentionPopup.value = false
    router.back()
}

defineExpose({
    handleShowRetentionPopup
})

window.addEventListener('paymentResult', function () {
    showRetentionPopup.value = false
});
</script>

<style scoped lang="scss">
.vip-u {
    .vip-u-text {
        margin-top: 14px;
        text-align: center;
        background: linear-gradient(0deg, #AD62F2 0%, #D4B3FF 47%, #AD62F2 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        font-weight: 800;
        font-size: 20px;
        font-style: italic;
    }

    .vip-u-text-2 {
        text-align: center;
        font-weight: 500;
        font-size: 14px;
        color: v-bind('theme.colors.textPrimary');
    }

    .vip-u-benefit-box {
        .vip-u-benefit-list {
            border-radius: 15px;
            border: 1px solid #AEA1B5;

            // border-image: linear-gradient(180deg, rgba(174, 161, 181, 1), rgba(186, 138, 221, 1)) 1 1;
            .header-item {
                border-bottom: 1px solid rgba(255, 255, 255, 0.1);
            }
        }
    }

    .bottom {
        position: absolute;
        top: -20px;
        left: 195px;
        width: 59px;
        height: 30px;
        border-radius: 10px 10px 0 0;

        // background: red;
        // background: #4D3362;
        // background: linear-gradient(180deg, #4D3362 0%, #4D3362 100%);
        background: #4B3557;



    }

    .top {
        width: 59px;
        height: calc(100% + 20px);
        position: absolute;
        bottom: 0px;
        border-radius: 10px 10px 0 0;
        left: 195px;

        // background: linear-gradient(180deg, #4D3362 0%, #19100F 100%);
        background: linear-gradient(180deg, rgba(190, 140, 255, 0.31) 0%, rgba(190, 140, 255, 0) 100%);
        opacity: 0.9;
    }

    .tab-box {
        box-shadow: 0px -4px 10px 2px rgba(0, 0, 0, 1);
    }

    .tab-subscribe-box {
        position: absolute;
        top: 67px;
        left: 0px;
        justify-content: space-between;


        .tab-subscribe-item {
            backdrop-filter: blur(10px);

            padding: 10px 0;
            border-radius: 10px;
            // border: 1px solid #AEA1B5;
            background: rgba(255, 255, 255, 0.1);
            // background: #3B3433;
            border: 2px solid transparent;
            position: relative;
            width: 110px;

            &.subscribe-active {
                backdrop-filter: blur(0px);

                // background: linear-gradient(90deg, #1A1114 0%, #684135 100%);
                background: linear-gradient(90deg, #1A1114 0%, #513568 100%);
                border: none;
                width: 120px;

                &::before {
                    content: '';
                    position: absolute;
                    inset: -2px;
                    border-radius: 10px;
                    padding: 2px;
                    background: linear-gradient(90deg, rgba(216, 197, 255, 1), rgba(205, 166, 255, 1));
                    -webkit-mask:
                        linear-gradient(#fff 0 0) content-box,
                        linear-gradient(#fff 0 0);
                    -webkit-mask-composite: xor;
                    mask:
                        linear-gradient(#fff 0 0) content-box,
                        linear-gradient(#fff 0 0);
                    mask-composite: exclude;
                    pointer-events: none;
                    z-index: 0;
                }

                >* {
                    position: relative;
                    z-index: 1;
                }
            }
        }
    }

    .subscribe-now-btn {
        margin-top: 20px;
        width: 100%;
        height: 40px;
        background: linear-gradient(90deg, #E9D6FF 0%, #A66CFE 100%);
        border-radius: 35px;
        text-align: center;
        line-height: 40px;
        font-weight: 800;
        font-size: 15px;
        color: #490D73;
    }

    .off-pic-box {
        // background: url('@/assets/images/vip/off-pic.png') no-repeat center center;
        // background-size: 100% 100%;
        border-radius: 20px;
        font-weight: bold;
        font-size: 9px;
        color: #FFFFFF;
    }
}

// 挽留弹窗样式
.retention-popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
}

.retention-popup-wrapper {
    width: 100%;
    max-width: 335px;
    padding: 1px;
    background: linear-gradient(135deg, rgba(233, 214, 255, 1), rgba(166, 108, 254, 1));
    // border-image: linear-gradient(135deg, rgba(233, 214, 255, 1), rgba(166, 108, 254, 1));
    border-radius: 20px;
    position: relative;
}

.retention-popup-container {
    width: 100%;
    // background: linear-gradient(180deg, #1D265F 0%, #171A2A 100%);
    background: linear-gradient(180deg, #40166B 0%, #140325 100%);
    border-radius: 20px;
    padding: 30px 20px 20px;
    position: relative;
    // box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
}

.retention-icon-wrapper {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
}

.retention-icon-border {
    position: relative;
    // padding: 8px;
    // border: 1px dashed rgba(214, 223, 255, 0.5);
    border-radius: 8px;
}

.retention-icon-circle {
    width: 107px;
    height: 50px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.retention-crown-icon {
    width: 100%;
    height: 100%;
}

.retention-title {
    text-align: center;
    font-size: 17px;
    font-weight: 900;
    color: #FFFFFF;
    margin-bottom: 12px;
}

.retention-description {
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 1.5;
    margin-bottom: 24px;
    opacity: 0.9;
}

.retention-buttons {
    display: flex;
    gap: 12px;
    justify-content: center;
}

.retention-btn {
    flex: 1;
    padding: 8px 20px;
    border-radius: 23px;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
}

.retention-btn-secondary {
    background: rgba(255, 255, 255, 0.1);
    color: #FFFFFF;
    font-weight: 800;
    font-size: 14px;
    color: #FFFFFF;

    &:active {
        background: rgba(255, 255, 255, 0.2);
        transform: scale(0.98);
    }
}

.retention-btn-primary {
    // background: linear-gradient(90deg, #5A68FF 0%, #95A5FF 100%);
    // background: linear-gradient(90deg, #D6DFFF 0%, #6990FF 100%);
    background: linear-gradient(90deg, #E9D6FF 0%, #A66CFE 100%);
    color: #FFFFFF;
    font-weight: 800;
    font-size: 15px;
    // color: #0D1D73;/
    color: #490D73;

    &:active {
        opacity: 0.9;
        transform: scale(0.98);
    }
}

// 弹窗动画
.retention-popup-enter-active,
.retention-popup-leave-active {
    transition: opacity 0.3s ease;
}

.retention-popup-enter-active .retention-popup-wrapper,
.retention-popup-leave-active .retention-popup-wrapper {
    transition: transform 0.3s ease, opacity 0.3s ease;
}

.retention-popup-enter-from {
    opacity: 0;
}

.retention-popup-enter-from .retention-popup-wrapper {
    transform: scale(0.9) translateY(20px);
    opacity: 0;
}

.retention-popup-leave-to {
    opacity: 0;
}

.retention-popup-leave-to .retention-popup-wrapper {
    transform: scale(0.9) translateY(-20px);
    opacity: 0;
}

.text {
    background: linear-gradient(0deg, #974BFF 0%, #CFABFF 47%, #974BFF 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: 24px;
    color: #FFFFFF;
    line-height: 29px;
    text-align: left;
    font-style: italic;
    font-weight: 600;
}
</style>